export default {"src":"/_next/static/media/close.850d55a4.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};